import { render, staticRenderFns } from "./RoomInfoAdmin.vue?vue&type=template&id=26e6e2b2&"
import script from "./RoomInfoAdmin.vue?vue&type=script&lang=js&"
export * from "./RoomInfoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports